import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import {
  ColectivoEspecialDTO,
  ColectivoEspecialRequest,
} from '../../models/colectivo-especial/colectivo-especial.model';

@Injectable({
  providedIn: 'root',
})
export class ColectivoEspecialService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.COLECTIVO_ESPECIAL}`;

  constructor(private http: HttpClient) {}

  consultarColectivoEspecial(
    request: ColectivoEspecialRequest,
  ): Observable<ColectivoEspecialDTO> {
    const nit = String(request.nit ?? '').trim();
    if (!nit) {
      return of({ colectivoEspecial: 'N' });
    }

    return this.http
      .post<unknown>(this.apiUrl, { nit })
      .pipe(map((response) => ColectivoEspecialService.mapResponse(response)));
  }

  private static mapResponse(
    raw: unknown,
    depth = 0,
  ): ColectivoEspecialDTO {
    if (raw == null || depth > 8) {
      return { colectivoEspecial: 'N' };
    }

    if (typeof raw === 'string') {
      const t = raw.trim();
      if (!t) {
        return { colectivoEspecial: 'N' };
      }
      if (t.startsWith('{') || t.startsWith('[')) {
        try {
          return ColectivoEspecialService.mapResponse(JSON.parse(t), depth + 1);
        } catch {
          return ColectivoEspecialService.normalizarValor(t);
        }
      }
      return ColectivoEspecialService.normalizarValor(t);
    }

    if (Array.isArray(raw)) {
      if (raw.length === 0) {
        return { colectivoEspecial: 'N' };
      }
      return ColectivoEspecialService.mapResponse(raw[0], depth + 1);
    }

    if (typeof raw === 'object') {
      const o = raw as Record<string, unknown>;
      for (const key of [
        'data',
        'Data',
        'result',
        'Result',
        'content',
        'jsonRespuesta',
        'JsonRespuesta',
      ]) {
        if (key in o && o[key] != null) {
          return ColectivoEspecialService.mapResponse(o[key], depth + 1);
        }
      }

      const val =
        o['colectivoEspecial'] ??
        o['ColectivoEspecial'] ??
        o['valor'] ??
        o['value'];
      if (val != null && typeof val === 'object') {
        return ColectivoEspecialService.mapResponse(val, depth + 1);
      }
      return ColectivoEspecialService.normalizarValor(val);
    }

    return { colectivoEspecial: 'N' };
  }

  private static normalizarValor(val: unknown): ColectivoEspecialDTO {
    if (val == null || String(val).trim() === '') {
      return { colectivoEspecial: 'N' };
    }
    const s = String(val).trim().toUpperCase();
    return { colectivoEspecial: s === 'S' ? 'S' : 'N' };
  }
}
